module.exports = __webpack_public_path__ + "static/media/twitter.cf9521e5.svg";